import React from 'react'
import { Link } from 'react-router'

const NotFound = () => {
    return (
        <div className='h-screen w-full center-center flex-col gap-4'>
            <p className='text-7xl font-bold text-[var(--color-blue)]'>404</p>
            <p className='text-[var(--text-gray)]'>Sorry, the page you’re looking for doesn’t exist.</p>
            <Link to='/' className='button-black'>Go to Dashboard</Link>
        </div>
    )
}

export default NotFound
